import { colors } from "../colors";
let gridSize = 8;
let swsPlotOptions = {
  chart: {
    type: "line",
    backgroundColor: null,
    plotBackgroundImage: "",
    animation: false,
    plotBorderWidth: 0,
    marginRight: 20,
    // zoomType: "xy",
  },
  credits: {
    enabled: false,
  },
  boost: {
    enabled: false, // enable animation
    useGPUTranslations: true,
    seriesThreshold: 0,
  },
  title: {
    text: null, //"Constructive Interference",
  },
  yAxis: {
    title: {
      text: "Depth from Skin Surface (mm)",
      offset: -30,
      useHTML: true,
      style: {
        color: colors.chartAxisLabel,
        "border-radius": "4px",
        padding: "5px",
        "background-color": colors.chartAxisBkg,
      },
    },
    labels: {
      formatter: null,
      step: 5,
      // format: "{value}",
      style: {
        color: colors.chartAxisLabel,
      },
    },
    plotLines: [
      {
        // Slice start (line)
        color: colors.swsPlotLine,
        width: 2,
        value: 0,
        dashStyle: "dash",
        zIndex: 10,
        className: "sliceLineStart sliceLine",
      },
      {
        // Slice start (grabbable region)
        color: colors.swsPlotLineBkg,
        width: 20,
        value: 0,
        zIndex: 9,
        className: "sliceRegionStart sliceRegion",
      },
      {
        // Slice end (line)
        color: colors.swsPlotLine,
        width: 2,
        value: 0,
        dashStyle: "dash",
        zIndex: 10,
        className: "sliceLineEnd sliceLine",
      },
      {
        // Slice end (grabbable region)
        color: colors.swsPlotLineBkg,
        width: 20,
        value: 0,
        zIndex: 9,
        className: "sliceRegionEnd sliceRegion",
      },
    ],
    plotBands: [
      {
        // ROI
        color: colors.plotBandROI,
        from: 0,
        to: 0,
        zIndex: 100,
        className: "plotBandROI",
      },
      // {
      //   // Area Above Skin Surface
      //   color: {
      //     // https://api.highcharts.com/class-reference/Highcharts.PatternOptionsObject
      //     pattern: {
      //       path: {
      //         // https://api.highcharts.com/class-reference/Highcharts.SVGAttributes
      //         d: `M 0 ${gridSize} L ${gridSize} 0 M -1 1 L 1 -1 M ${
      //           gridSize - 1
      //         } ${gridSize + 1} L ${gridSize + 1} ${gridSize - 1}`,
      //         strokeWidth: 1,
      //       },
      //       width: gridSize,
      //       height: gridSize,
      //       id: "diagonalLines",
      //       color: colors.swsPlotStrokeColor, // stroke color
      //       backgroundColor: colors.swsPlotNoGoZoneBkg,
      //       opacity: 1,
      //     },
      //   },
      //   from: 0,
      //   to: 0,
      //   borderColor: colors.swsPlotStrokeColor,
      //   borderWidth: 0.5,
      //   zIndex: 1,
      //   id: "above",
      //   className: "plotBandAboveBelow",
      // },
      // {
      //   // Deep No-go Zone
      //   color: "url(#diagonalLines)",
      //   from: 0,
      //   to: 0,
      //   borderColor: colors.swsPlotStrokeColor,
      //   borderWidth: 0.5,
      //   zIndex: 1,
      //   id: "below",
      //   className: "plotBandAboveBelow",
      // },
    ],
    startOnTick: true,
    endOnTick: true,
    reversed: true,
    min: 0,
    max: 15,
    tickInterval: 0.2,
    tickWidth: 1,
    lineWidth: 1, // y-axis line
    gridLineWidth: 0,
    minorGridLineWidth: 0,
    // tickPixelInterval: 25,
  },
  xAxis: {
    title: {
      text: "sws (m/s)",
      offset: -30,
      useHTML: true,
      style: {
        color: colors.chartAxisLabel,
        "border-radius": "4px",
        padding: "5px",
        "background-color": colors.chartAxisBkg,
      },
    },
    labels: {
      format: "{value}",
      style: {
        color: colors.chartAxisLabel,
      },
    },
    startOnTick: false,
    endOnTick: false,
    min: 0,
    max: 8,
    tickWidth: 1,
    tickInterval: 0.5, // The interval of the tick marks in axis units
  },
  legend: {
    enabled: false,
  },
  plotOptions: {
    heatmap: {
      animation: false,
      stickyTracking: true,
      shadow: false,
    },
    series: {
      enableMouseTracking: false,
    },
  },
  series: [
    {
      // name: "Constructive Interference",
      type: "line",
      borderWidth: 0,
      nullColor: colors.chartNullColor,
      tooltip: {
        enabled: false,
      },
      showInLegend: false,
      colsize: 0.001, // how many X axis units each column in the heatmap should span
      rowsize: 0.001, // how many Y axis units each heatmap row should span.
    },
  ],
};

export { swsPlotOptions };
